import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { endpoints } from '../endpoints';
import { CodeMultipleHierarchyPicker } from '../../common';
import { CodeMultiplePickerProps } from './types';
import { getValidationWithoutDuplicates } from 'app/area/codetable/item/code-pickers/helpers';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const CodeCaseTypes = (props: CodeMultiplePickerProps) => {

  const { metadata, codeItem, onChange, options, loadOptions, translation, locale, 
    validation, readOnly, displaySelectAll } = props;

  if (!metadata || !metadata.features || !metadata.features.caseType) {
    return null;
  }

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(id, endpoints.caseType, loadOptionsParams);
  };

  const codeOptions = (!!options && !!options.caseTypes && options.caseTypes.codes || []) as CodeComplexValue<number>[];

  const caseTypesValidation = !!validation && !!validation.application ? getValidationWithoutDuplicates(validation.application) : undefined;

  return <>
    <CodeMultipleHierarchyPicker
      id="caseTypes"
      label={translation.visible_for_case_types}
      valueItems={codeItem && codeItem.caseTypes}
      validation={caseTypesValidation}
      options={codeOptions}
      fetchingOptions={options && options.caseTypes && options.caseTypes.fetching}
      readOnly={readOnly}
      displaySelectAll={displaySelectAll}
      translation={translation}
      locale={locale}

      onLoadOptions={onLoadOptions}
      onChange={onChange}
    />
  </>;
};
